<template>
  <section>
    <b-loading v-model="isLoading" />
    <div
      v-for="[region, structures] in regionProjects"
      :key="region"
      class="structure-projets-view"
    >
      <H3TitleView class="modal-card-title">{{ region }}</H3TitleView>
      <div class="StructureProjetsView-cards">
        <div v-for="project in structures" :key="project.id">
          <ProjectCard :project="project" :logged-user="loggedUser" />
        </div>
      </div>
    </div>
    <b-message v-if="!isLoading && regionProjects.size === 0" type="is-warning">
      {{ $t("structurePage.noProjects") }}
    </b-message>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { ProjetAnnuelLightDTO, UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { LoginService } from "@/services/rest/login/LoginService"
import { ProjectService } from "@/services/rest/project/ProjectService"
import ProjectCard from "@/views/projects_pp/ProjectCard.vue"
import H3TitleView from "@/views/commons/H3TitleView.vue"
import { BMessage, BLoading } from "buefy"

export default defineComponent({
  name: "StructureProjetsView",
  components: {
    H3TitleView,
    ProjectCard,
    BMessage,
    BLoading,
  },
  props: {
    structureId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loginService: LoginService.INSTANCE,
      projectService: ProjectService.INSTANCE,
      isLoading: false,
      loggedUser: new UtilisateurDTO(),
      regionProjects: new Map<string, ProjetAnnuelLightDTO[]>(),
    }
  },
  watch: {
    async structureId(newVal: string, oldVal: string): Promise<void> {
      if (newVal !== oldVal) {
        await this.fetchProjects()
      }
    },
  },
  async created(): Promise<void> {
    this.isLoading = true
    try {
      await this.fetchProjects()
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    async fetchProjects(): Promise<void> {
      const loggedUser = this.loginService.getLoggedUser()
      if (!loggedUser) {
        return
      }
      this.loggedUser = loggedUser
      const structureProjects: ProjetAnnuelLightDTO[] =
        await this.projectService.getProjectsOfStructure(this.structureId)

      if (structureProjects.length > 0) {
        this.regionProjects = this.updateRegionProjectMap(structureProjects)
      }
    },

    updateRegionProjectMap(structures: ProjetAnnuelLightDTO[]) {
      // Création de la Map avec region comme clé
      return structures.reduce((map, structure) => {
        if (!map.has(structure.grae?.region)) {
          map.set(structure.grae.region, [])
        }
        map.get(structure.grae?.region)?.push(structure)
        return map
      }, new Map<string, ProjetAnnuelLightDTO[]>())
    },
  },
})
</script>

<style lang="scss">
.structure-projets-view + .structure-projets-view {
  margin-top: 2.5em;
}

.structure-projets-view:last-of-type {
  margin-bottom: 1em;
}

.StructureProjetsView-cards {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .ProjectCard {
    margin-left: 0.5rem;
  }
}
</style>
